/**
 * Created by lijuncheng on 2017/3/11.
 */

/********
 * 使用方法
 *
 this.$api.post("idd_global_phone_query", {"phone":"18519099219"},function (ret) {
         // 请求成功
         alert(ret.msg);
       }, function (ret) {
         // 请求失败
         alert(ret.msg);
      }
 );
 *
 *********/
import vue from '../../src/main.js'

// 配置API接口地址
var baseurl = "https://qu.starfast.cn/api/"  // 生产环境
// var baseurl = "http://s1.dev.starfast.cn/api/"  // 测试环境

var root = baseurl + "gateway";

var appid = "cmlink2ae4d74262a248a4df0e9012d2";  //  应用id
var aes_key = "CMLINK19A070SDM1";  //  AES密钥

// 引用superagent
var request = require('superagent');
var CryptoJS = require("crypto-js");


// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filter_null(o) {
  for (var key in o) {
    if (o[key] == null) {
      delete o[key]
    }
    if (toType(o[key]) == 'string') {
      o[key] = o[key].trim()
      if (o[key].length == 0) {
        delete o[key]
      }
    }
  }
  return o
}
/*
 接口处理函数
 */
function _api_base(method, url, params, success, failure, testthis) {


  var httpparams;
  if (params) {

    // params = filter_null(params);
    var parmstr = JSON.stringify(params);
    var key = CryptoJS.enc.Utf8.parse(aes_key);
    var srcs = CryptoJS.enc.Utf8.parse(parmstr);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    var encryptedstr = encrypted.ciphertext.toString().toUpperCase();

    httpparams = {
      'appid':appid,
      'method':url,
      'sign':encryptedstr
    };

  } else {
    httpparams = {
      "appid":appid,
      "method":url
    };
  }

  request.post(root)
    .type('form')
    .send(httpparams)
    .end(function(err, res){

      if (err) {
        failure(err);
        var name = vue.vueinit.$route.name
        vue.vueinit.$router.push({name:'offline',query:{from:name}})
        return;
      }

      var resjson = JSON.parse(res.text);
      if (resjson.code == 0) {
        success(_decrypt(resjson.sign));
      } else if (resjson.code == 1) {
        alert("参数不能为空");
      } else if (resjson.code == 2) {
        alert("接口方法名有误");
      } else if (resjson.code == 3) {
        alert("appid有误");
      } else if (resjson.code == 4) {
        alert("请求密文有误");
      } else if (resjson.code >= 5 && resjson.code <= 8) {
        if(testthis!= undefined){
          var name = testthis.$route.name
          testthis.$router.replace({name: 'login', query: {from: name}})
        }else {
          failure("用户登录信息失效")
        }
      }
      // else if (resjson.code == 5) {
      //   alert("用户id与用户token不能为空");
      // } else if (resjson.code == 6) {
      //   alert("用户token不存在或已失效");
      // } else if (resjson.code == 7) {
      //   alert("管理员id和token不能为空");
      // } else if (resjson.code == 8) {
      //   alert("管理员token不存在或已失效");
      // }
      else {
        alert("未知错误");
      }
    });

};

function _decrypt(word) {
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var key = CryptoJS.enc.Utf8.parse(aes_key);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, { mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedStr.toString());
}

// 返回在vue模板中的调用接口
export default {
  get: function(url, params, success, failure) {
    return _api_base('GET', url, params, success, failure)
  },
  post: function(url, params, success, failure, testthis) {
    return _api_base('POST', url, params, success, failure, testthis)
  },
  put: function(url, params, success, failure) {
    return _api_base('PUT', url, params, success, failure)
  },
  delete: function(url, params, success, failure) {
    return _api_base('DELETE', url, params, success, failure)
  },

  decrypt:function (word) {
    return _decrypt(word)
  },

  encrypt:function (params) {

    var parmstr = JSON.stringify(params);
    var key = CryptoJS.enc.Utf8.parse(aes_key);
    var srcs = CryptoJS.enc.Utf8.parse(parmstr);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    var encryptedstr = encrypted.ciphertext.toString().toUpperCase();

    return encryptedstr;
  },

  user_id:function () {
    var user_id = localStorage.getItem('xs_user_id');
    return user_id
  },

  set_user_id:function (user_id) {
    localStorage.setItem('xs_user_id', user_id);
    localStorage.setItem('xs_idd_im_user_id', user_id)
  },

  user_token:function () {
    var user_token = localStorage.getItem('xs_user_token');
    return user_token
  },

  set_user_token:function (user_token) {
    localStorage.setItem('xs_user_token', user_token);
  },


  /* 判断是否已登录 */
  isLogin:function () {
    var user_token = localStorage.getItem('xs_user_token');
    if (user_token) {
      return true
    } else {
      return false
    }

  },

  logout:function (){
    localStorage.removeItem("xs_user_id");
    localStorage.removeItem("xs_user_token");
    localStorage.removeItem("xs_user_wx_openid");
  },

  //搜索历史
  set_search_history:function (str) {
    var search_history = localStorage.getItem('xs_search_history');
    if(search_history!=null && search_history!=""){
      search_history = str+"&&"+search_history
    }else {
      search_history = str
    }
    localStorage.setItem('xs_search_history', search_history);
  },
  get_search_history:function () {
    return  localStorage.getItem('xs_search_history');
  },
  clear_search_history:function () {
    localStorage.setItem('xs_search_history', "");
    var search_history = localStorage.getItem('xs_search_history')
    if(search_history==""){
      return true
    }else {
      return false
    }
  },
  set_protocol_flags:function (boolean) {
    localStorage.setItem('xs_protocol_flags', boolean);
  },
  get_protocol_flags:function () {
    localStorage.getItem('xs_protocol_flags');
  },
// 判断是否是微信浏览器打开
  isweixinbrowser:function (){
    var browser = {
      versions: function () {
        var u = navigator.userAgent, app = navigator.appVersion;
        return {         //移动终端浏览器版本信息
          trident: u.indexOf('Trident') > -1, //IE内核
          presto: u.indexOf('Presto') > -1, //opera内核
          webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
          iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, //是否iPad
          webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        };
      }(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }

    if (browser.versions.mobile) {//判断是否是移动设备打开。browser代码在下面
      var ua = navigator.userAgent.toLowerCase();//获取判断用的对象

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //在微信中打开
        return true;
      } else {
        return false;
      }

      // if (ua.match(/WeiBo/i) == "weibo") {
      //     //在新浪微博客户端打开
      // }
      // if (ua.match(/QQ/i) == "qq") {
      //     //在QQ空间打开
      // }
      // if (browser.versions.ios) {
      //     //是否在IOS浏览器打开
      // }
      // if(browser.versions.android){
      //     //是否在安卓浏览器打开
      // }
    } else {
      //否则就是PC浏览器打开
      return false;
    }
  },

  locationChange:function(val){
    window.location = baseurl + val;
  },

  is_ios:function(){
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
  },

  fileUpload:function(file, next, errnext){

    request.post(baseurl+'file/upload')
      .field('folderPath', 'cmfeedback/')
      .attach('file', file)
      .end(function(err, res){
        if (res) {
          console.log(res)
          var json = JSON.parse(res.text)
          next(json.data)
        } else {
          console.log(err)
          errnext(err)

        }
      });

  },


}








//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 